 
import React from "react";

import { PageLoader } from "../../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../../constants/enums";
import { useCustomerPolicyDetails } from "../../../../../hooks";
import { useOutletContext } from "react-router-dom";
import { AutomobileVehicleInformationList } from "./AutomobileVehicle/AutomobileVehicleInformation/AutomobileVehicleList";
import { PageContainer } from "../../../../../components/container/PageContainer";

export const AutoVehicleRoot: React.FC = () => {
  const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];
  const { details } = useCustomerPolicyDetails(customerPolicyId);


  return (
    <PageContainer title="Vehicle" description="this is inner page">
    <PageLoader
      loading={details.loading === LoadState.InProgress}
      error={details.error ? { message: details.error } : null}
    >
      <>
        <AutomobileVehicleInformationList
          customerId={customerId}
          customerPolicyId={customerPolicyId}
        />
      </>
    </PageLoader>
    </PageContainer>
  );
};
